import { Injectable } from "@angular/core";
import { AccountingPeriodBlock } from "../models/AccountingPeriodBlock.model";
import { HttpClient } from "../shared/wrappers/HttpClient";

@Injectable()
export class AccountingPeriodBlockService {
    constructor(private httpClient: HttpClient) { }

    endPoint: String = "/accountingPeriodBlock";

    async create(accountingData: AccountingPeriodBlock): Promise<any> {
        const res = await this.httpClient.post(this.endPoint, accountingData);
        return res;
    }

    async getAllBlockedPeriods(): Promise<AccountingPeriodBlock[]> {
        const response = await this.httpClient.get(`${this.endPoint}`) as AccountingPeriodBlock[];
        if(response === null) {
            return null;
        }
        return response;
    }

    async update(accountingData: AccountingPeriodBlock): Promise<any> {
        const response = await this.httpClient.update(this.endPoint, accountingData._id, accountingData);
        return response;
    }

}



// WEBPACK FOOTER //
// ./src/app/services/accountingBlock.service.ts